import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function getToken() {
  try { return localStorage.getItem("spora1_token"); } catch (e) { return window.__spora1_token || null; }
}
export function setToken(t) {
  try { localStorage.setItem("spora1_token", t); } catch (e) { window.__spora1_token = t; }
}
export function clearToken() {
  try { localStorage.removeItem("spora1_token"); } catch (e) { console.warn("Token storage unavailable", e); }
  window.__spora1_token = null;
}

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatINR(n) {
  const v = Number(n || 0);
  return "₹" + v.toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export default api;
